<template>
  <a-modal title="随机专家筛选条件设置"
           :width="900"
           :visible="visible"
           :maskClosable="false"
           destroyOnClose
           @cancel="cancel()"
  >
    <template slot="footer">
      <a-button key="submit" :loading="loading" type="primary" @click="submit">确定</a-button>
    </template>
    <div class="table-page-search-wrapper">
      <a-form :form="qForm" layout="inline" style="width: 80%">
        <a-row>
          <a-col>
            <a-form-item label="年龄">
              <a-input-number style="width: 35%" v-model="trip.ageSt"/>&nbsp;
              到&nbsp;
              <a-input-number style="width: 35%" v-model="trip.ageEt"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="性别">
<!--              <dict-radio placeholder="性别"-->
<!--                          dictKey="PEOPLE.SEX"-->
<!--                          v-model="trip.gender"-->
<!--                          @change="(val) => { trip.gender = val }"-->
<!--              />-->

              <dict-cascader dictKey="PEOPLE.SEX"
                             placeholder="性别"
                             v-model="trip.gender"
                             @change="(val) => { trip.gender = val }"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <a-form-item label="职称">
              <dict-cascader dictKey="expert_professionalTitle"
                             placeholder="职称"
                             v-model="trip.professionalTitle"
                             @change="(val) => { trip.professionalTitle = val }"
                             style="width: 71%"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import DictCascader from '@comp/dict/DictCascader'
import DictRadio from '@comp/dict/DictRadio'
import qs from 'qs'

export default {
  name: 'SelectConditionModal',
  components: {
    DictCascader,
    DictRadio
  },
  created () {
  },
  data () {
    return {
      visible: false,
      loading: false,
      qForm: this.$form.createForm(this),
      id: '88633f7f-2ffb-4d8a-b478-43c12ad331ee',
      trip: {},
      isUpdate: false
    }
  },
  methods: {
    onStartLoadData (isT) {
      const that = this
      that.visible = true
      that.isUpdate = isT
      that.$http.get(`/api/1/expertmain/condition/get_condition.json?id=` + that.id).then(res => {
        if (res.code !== 200) {
          return
        }
        that.trip = res.result
      })
    },
    submit () {
      const that = this
      that.trip.id = that.id
      // 更新查询条件
      this.$http.post(`/api/1/expertmain/condition/update_condition.json`, qs.stringify(that.trip)).then(res => {
        if (res.code !== 200) {
          return
        }
        that.visible = false
        that.trip.isUpdate = that.isUpdate
        that.$emit('success', that.trip)
      })
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
